export const referencing = [
  { value: "APA", label: "APA" },
  { value: "Chicago", label: "Chicago" },
  { value: "Harvard", label: "Harvard" },
  { value: "MLA", label: "MLA" },
  { value: "OSCOLA", label: "OSCOLA" },
  { value: "Other", label: "Other" },
];
